import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { useUserContext } from '@/Context/UserContext';
import UIStrings from '@/Utils/UIStrings';

export const profileInfoSchema = z.object({
    firstName: z.string().min(1, UIStrings.Required),
    lastName: z.string().min(1, UIStrings.Required),
    signature: z
        .string()
        .min(1, UIStrings.Required)
        .max(1000, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
});

export type ProfileInfoFormValues = z.infer<typeof profileInfoSchema>;

export const useProfileInfoForm = () => {
    const { user } = useUserContext();

    return useForm<ProfileInfoFormValues>({
        resolver: zodResolver(profileInfoSchema),
        mode: 'onSubmit',
        defaultValues: { firstName: user.firstName, lastName: user.lastName, signature: '' },
    });
};

export const useProfileInfoFormContext = () => useFormContext<ProfileInfoFormValues>();
